import { NotFound } from 'component/errors/not-found';
import { View } from 'react-native';
import { Catcher } from 'system/catcher';
import { useStructureModule } from 'util/datastore';
import { useNotifyHostAboutDimensionOnLayoutHandler } from 'util/iframe-messaging';

export default function ArticleTeaserScreen() {
    const onLayout = useNotifyHostAboutDimensionOnLayoutHandler();
    const { teaser: Teaser } = useStructureModule().structure;

    if (!Teaser) {
        return <NotFound />;
    }

    return (
        <View onLayout={onLayout}>
            <Catcher>
                <Teaser />
            </Catcher>
        </View>
    );
}
